module.exports = __webpack_public_path__ + "static/media/auction.2dce383d.png";